import Vue from 'vue';
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
// import bugsnag from '@bugsnag/js';
// import bugsnagVue from '@bugsnag/plugin-vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import './http';

// if (process.env.VUE_APP_BUGSNAG_RELEASE_STAGE !== 'local') {
//   const bugsnagClient = bugsnag({
//     apiKey: process.env.VUE_APP_BUGSNAG_API_KEY,
//     beforeSend: (report) => {
//       report.app.releaseStage = process.env.VUE_APP_BUGSNAG_RELEASE_STAGE;
//       report.app.version = process.env.VUE_APP_VERSION;

//       const user = store.getters['auth/user'];

//       if (user) {
//         report.user = {
//           id: user.id,
//           eventId: store.state.auth.eventId,
//         };
//       }
//     },
//   });

//   bugsnagClient.use(bugsnagVue, Vue);
// }

Vue.config.productionTip = false;

extend('required', {
  ...required,
  message: 'This field is required',
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
